import React from 'react'
import ReactModal from 'react-modal'

// variant: "danger" (default, red confirm) | "primary" (brass confirm). title defaults to "Are you sure?"
// busy: the action is running - both buttons are disabled and the confirm button shows busyLabel
function AreYouSureModal({uploadNew, onClose, doNotClose = true, onBack, buttonName = "Yes", onSubmit, text, title = "Are you sure?", variant = "danger", busy = false, busyLabel = "Please wait…"}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {doNotClose && !busy}
    shouldCloseOnOverlayClick = {doNotClose && !busy}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 55,
          backgroundColor: 'rgba(20,33,61,.4)'
        },
        content: {
            zIndex: 55,
            height: 'auto',
            width: 'auto',
            maxWidth: '380px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px 32px',
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '4px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 12px 32px rgba(20,33,61,.3)',
        }
      }}
    >    
        <div className='flex items-center flex-col text-center font-plexsans'>
            <div className='font-spectral font-normal text-[17px] leading-[1.4] text-navy mb-2'>{title}</div>
            <div className='font-plexsans font-normal text-[13px] leading-[1.6] text-navy/[.55]'>
             { text ? 
              text 
              :
              "This action cannot be reversed."}</div>
            <div className='flex gap-2.5 w-full mt-6 justify-center'>
                <div
                aria-disabled={busy || undefined}
                className={`text-center rounded-sm whitespace-nowrap font-plexsans font-medium text-[13px] leading-none text-navy/[.6] border border-navy/[.2] py-3 px-5 ${busy ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={busy ? undefined : (onBack ? onBack : onClose)}>Go back</div>
                <div
                aria-disabled={busy || undefined}
                className={`text-center rounded-sm whitespace-nowrap font-plexsans font-medium text-[13px] leading-none text-ivory border-0 py-3 px-5 ${variant === "primary" ? "bg-brass hover:bg-brassDark" : "bg-danger"} ${busy ? 'opacity-70 cursor-wait' : 'cursor-pointer'}`}
                onClick={busy ? undefined : onSubmit}>{busy ? busyLabel : buttonName}</div>
            </div>
         </div>
    </ReactModal>
  )
}

export default AreYouSureModal
